import { DatePicker } from "antd";
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

const AntdDatePicker = DatePicker.generatePicker(momentGenerateConfig);

export default AntdDatePicker;
